export default __webpack_public_path__ + "static/media/money-back@3x.5f7388aa.png";